module.exports = __webpack_public_path__ + "assets/1324da082dc5839f8959d4f6fb6da83f.png";